import { render, staticRenderFns } from "./EventViewCustomUser.vue?vue&type=template&id=2cc47fc3&"
import script from "./EventViewCustomUser.vue?vue&type=script&lang=js&"
export * from "./EventViewCustomUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports